import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/components/app-logo.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/components/auth/auth-form.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/.pnpm/next-axiom@1.1.1_next@14.2.4_@babel+core@7.23.3_babel-plugin-macros@3.1.0_react-dom@18.2.0_re_okloyx44w22zf4t3g4dkpze6ea/node_modules/next-axiom/dist/webVitals/components.js");
